import { Controller } from "@hotwired/stimulus"
import consumer from "../../channels/consumer"

export default class extends Controller {
  static targets = ["content", "status"]
  static values = {
    valuationId: Number
  }

  connect() {
    if (!this.valuationIdValue) return

    this.channel = consumer.subscriptions.create(
      {
        channel: "ValuationPresenceChannel",
        valuation_id: this.valuationIdValue
      },
      {
        connected: () => {
          this.startPingInterval()
          this.hideConnectionWarning()
        },
        disconnected: () => {
          this.stopPingInterval()
          this.showConnectionWarning()
        },
        rejected: () => {
          this.showConnectionWarning()
        },
        received: (data) => {
          if ('html_new' in data) {
            this.contentTarget.innerHTML = data.html_new
          }
        }
      }
    )
  }

  disconnect() {
    this.stopPingInterval()
    if (this.channel) {
      this.channel.unsubscribe()
    }
  }

  startPingInterval() {
    this.pingInterval = setInterval(() => {
      try {
        this.channel.perform('ping')
      } catch (error) {
        console.error('Error during ping:', error)
        this.channel.consumer.connection.reopen()
      }
    }, 20000)
  }

  stopPingInterval() {
    if (this.pingInterval) {
      clearInterval(this.pingInterval)
    }
  }

  showConnectionWarning() {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = 'Connection lost'
      this.element.classList.add('opacity-50')
    }
  }

  hideConnectionWarning() {
    if (this.hasStatusTarget) {
      this.element.classList.remove('opacity-50')
    }
  }
}
